import Splide from '@splidejs/splide'

import { getElementChildren, getElements } from '../Utility/Dom'

class MonitorSlider {
  private sliderOptions: object = {
    arrows: false,
    autoplay: true,
    clones: 0,
    drag: true,
    gap: 0,
    interval: 5000 * 5,
    pagination: false,
    perPage: 1,
    type: 'loop',
  }

  private sliderOptionsImage: object = {
    arrows: false,
    autoplay: true,
    clones: 0,
    drag: false,
    gap: 0,
    interval: 5000,
    pagination: false,
    perPage: 1,
    type: 'loop',
  }

  private sliders: NodeListOf<HTMLElement>

  constructor() {
    this.sliders = getElements('monitor-slider')
  }

  init(): void {
    this.sliders.forEach((slider: HTMLElement): void => {
      const imageSliderInstances: Map<number, Splide> = new Map()
      const imageSliders = getElementChildren(slider, 'monitor-image-slider')

      imageSliders.forEach((imageSlider: HTMLElement, index: number): void => {
        const slideCount = imageSlider.querySelectorAll('.splide__slide')?.length || 0
        const splideImage = new Splide(imageSlider, {
          ...this.sliderOptionsImage,
          pagination: slideCount > 1,
        })

        splideImage.mount()
        imageSliderInstances.set(index, splideImage)

        if (index !== 0) {
          splideImage.Components.Autoplay?.pause()
        }
      })

      const splide = new Splide(slider, this.sliderOptions)

      splide.on('moved', (newIndex: number): void => {
        imageSliderInstances.forEach((instance, index): void => {
          if (index === newIndex) {
            instance.go(0)
            instance.Components.Autoplay?.play()
          } else {
            instance.Components.Autoplay?.pause()
          }
        })
      })

      splide.mount()
    })
  }
}

const monitorSlider = new MonitorSlider()
monitorSlider.init()
